import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dDate$dComponent from "../Data.Date.Component/index.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dTime from "../Data.Time/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const bind1 = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const pure1 = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const UTCTime = x => x;
const unscrambleDecodeUTCTime = {
  unsafeDecode: value => {
    const str = Unscramble.decodeString(value);
    const v = DateUtils.parseISODateTime(str);
    if (v.tag === "Just") { return v._1; }
    if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid ISO8601 datetime: " + Data$dShow.showStringImpl(str)); }
    $runtime.fail();
  }
};
const parseYYYYMMDDhhmmssDateTime = dateTime => {
  const v = Data$dString$dCodePoints.splitAt(4)(dateTime);
  const v1 = Data$dString$dCodePoints.splitAt(2)(v.after);
  const v2 = Data$dString$dCodePoints.splitAt(2)(v1.after);
  const v3 = Data$dString$dCodePoints.splitAt(2)(v2.after);
  const v4 = Data$dString$dCodePoints.splitAt(2)(v3.after);
  const v$1 = Data$dString$dCodeUnits.toCharArray(v.before);
  const $0 = (() => {
    if (v$1.length === 4) {
      return Data$dMaybe.$Maybe(
        "Just",
        (
          (((Data$dEnum.toCharCode(v$1[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$1[1]) - 48 | 0) * 100 | 0) | 0) + ((Data$dEnum.toCharCode(v$1[2]) - 48 | 0) * 10 | 0) | 0
        ) + (Data$dEnum.toCharCode(v$1[3]) - 48 | 0) | 0
      );
    }
    if (v$1.length === 2) { return Data$dMaybe.$Maybe("Just", ((Data$dEnum.toCharCode(v$1[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$1[1]) - 48 | 0) | 0); }
    return Data$dMaybe.Nothing;
  })();
  const $1 = (() => {
    if ($0.tag === "Just") {
      if ($0._1 >= -271820 && $0._1 <= 275759) { return Data$dMaybe.$Maybe("Just", $0._1); }
      return Data$dMaybe.Nothing;
    }
    if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })();
  if ($1.tag === "Just") {
    const v$2 = Data$dString$dCodeUnits.toCharArray(v1.before);
    const $2 = (() => {
      if (v$2.length === 4) {
        return Data$dMaybe.$Maybe(
          "Just",
          (
            (((Data$dEnum.toCharCode(v$2[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$2[1]) - 48 | 0) * 100 | 0) | 0) + ((Data$dEnum.toCharCode(v$2[2]) - 48 | 0) * 10 | 0) | 0
          ) + (Data$dEnum.toCharCode(v$2[3]) - 48 | 0) | 0
        );
      }
      if (v$2.length === 2) { return Data$dMaybe.$Maybe("Just", ((Data$dEnum.toCharCode(v$2[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$2[1]) - 48 | 0) | 0); }
      return Data$dMaybe.Nothing;
    })();
    const $3 = (() => {
      if ($2.tag === "Just") { return Data$dDate$dComponent.boundedEnumMonth.toEnum($2._1); }
      if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if ($3.tag === "Just") {
      const v$3 = Data$dString$dCodeUnits.toCharArray(v2.before);
      const $4 = (() => {
        if (v$3.length === 4) {
          return Data$dMaybe.$Maybe(
            "Just",
            (
              (((Data$dEnum.toCharCode(v$3[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$3[1]) - 48 | 0) * 100 | 0) | 0) + (
                (Data$dEnum.toCharCode(v$3[2]) - 48 | 0) * 10 | 0
              ) | 0
            ) + (Data$dEnum.toCharCode(v$3[3]) - 48 | 0) | 0
          );
        }
        if (v$3.length === 2) { return Data$dMaybe.$Maybe("Just", ((Data$dEnum.toCharCode(v$3[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$3[1]) - 48 | 0) | 0); }
        return Data$dMaybe.Nothing;
      })();
      const $5 = (() => {
        if ($4.tag === "Just") {
          if ($4._1 >= 1 && $4._1 <= 31) { return Data$dMaybe.$Maybe("Just", $4._1); }
          return Data$dMaybe.Nothing;
        }
        if ($4.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      if ($5.tag === "Just") {
        const v$4 = Data$dString$dCodeUnits.toCharArray(v3.before);
        const $6 = (() => {
          if (v$4.length === 4) {
            return Data$dMaybe.$Maybe(
              "Just",
              (
                (((Data$dEnum.toCharCode(v$4[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$4[1]) - 48 | 0) * 100 | 0) | 0) + (
                  (Data$dEnum.toCharCode(v$4[2]) - 48 | 0) * 10 | 0
                ) | 0
              ) + (Data$dEnum.toCharCode(v$4[3]) - 48 | 0) | 0
            );
          }
          if (v$4.length === 2) { return Data$dMaybe.$Maybe("Just", ((Data$dEnum.toCharCode(v$4[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$4[1]) - 48 | 0) | 0); }
          return Data$dMaybe.Nothing;
        })();
        const $7 = (() => {
          if ($6.tag === "Just") {
            if ($6._1 >= 0 && $6._1 <= 23) { return Data$dMaybe.$Maybe("Just", $6._1); }
            return Data$dMaybe.Nothing;
          }
          if ($6.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        })();
        if ($7.tag === "Just") {
          const v$5 = Data$dString$dCodeUnits.toCharArray(v4.before);
          const $8 = (() => {
            if (v$5.length === 4) {
              return Data$dMaybe.$Maybe(
                "Just",
                (
                  (((Data$dEnum.toCharCode(v$5[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$5[1]) - 48 | 0) * 100 | 0) | 0) + (
                    (Data$dEnum.toCharCode(v$5[2]) - 48 | 0) * 10 | 0
                  ) | 0
                ) + (Data$dEnum.toCharCode(v$5[3]) - 48 | 0) | 0
              );
            }
            if (v$5.length === 2) { return Data$dMaybe.$Maybe("Just", ((Data$dEnum.toCharCode(v$5[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$5[1]) - 48 | 0) | 0); }
            return Data$dMaybe.Nothing;
          })();
          const $9 = (() => {
            if ($8.tag === "Just") {
              if ($8._1 >= 0 && $8._1 <= 59) { return Data$dMaybe.$Maybe("Just", $8._1); }
              return Data$dMaybe.Nothing;
            }
            if ($8.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          if ($9.tag === "Just") {
            const v$6 = Data$dString$dCodeUnits.toCharArray(v4.after);
            if (v$6.length === 4) {
              if (
                (
                  (
                    (((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$6[1]) - 48 | 0) * 100 | 0) | 0) + (
                      (Data$dEnum.toCharCode(v$6[2]) - 48 | 0) * 10 | 0
                    ) | 0
                  ) + (Data$dEnum.toCharCode(v$6[3]) - 48 | 0) | 0
                ) >= 0 && (
                  (
                    (((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$6[1]) - 48 | 0) * 100 | 0) | 0) + (
                      (Data$dEnum.toCharCode(v$6[2]) - 48 | 0) * 10 | 0
                    ) | 0
                  ) + (Data$dEnum.toCharCode(v$6[3]) - 48 | 0) | 0
                ) <= 59
              ) {
                const $10 = Data$dDate.exactDate($1._1)($3._1)($5._1);
                if ($10.tag === "Just") {
                  return Data$dMaybe.$Maybe(
                    "Just",
                    Data$dDateTime.$DateTime(
                      $10._1,
                      Data$dTime.$Time(
                        $7._1,
                        $9._1,
                        (
                          (((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 1000 | 0) + ((Data$dEnum.toCharCode(v$6[1]) - 48 | 0) * 100 | 0) | 0) + (
                            (Data$dEnum.toCharCode(v$6[2]) - 48 | 0) * 10 | 0
                          ) | 0
                        ) + (Data$dEnum.toCharCode(v$6[3]) - 48 | 0) | 0,
                        0
                      )
                    )
                  );
                }
                if ($10.tag === "Nothing") { return Data$dMaybe.Nothing; }
                $runtime.fail();
              }
              return Data$dMaybe.Nothing;
            }
            if (v$6.length === 2) {
              if (
                (((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$6[1]) - 48 | 0) | 0) >= 0 && (
                  ((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$6[1]) - 48 | 0) | 0
                ) <= 59
              ) {
                const $10 = Data$dDate.exactDate($1._1)($3._1)($5._1);
                if ($10.tag === "Just") {
                  return Data$dMaybe.$Maybe(
                    "Just",
                    Data$dDateTime.$DateTime(
                      $10._1,
                      Data$dTime.$Time($7._1, $9._1, ((Data$dEnum.toCharCode(v$6[0]) - 48 | 0) * 10 | 0) + (Data$dEnum.toCharCode(v$6[1]) - 48 | 0) | 0, 0)
                    )
                  );
                }
                if ($10.tag === "Nothing") { return Data$dMaybe.Nothing; }
                $runtime.fail();
              }
              return Data$dMaybe.Nothing;
            }
            return Data$dMaybe.Nothing;
          }
          if ($9.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        if ($7.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      }
      if ($5.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
    if ($3.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
  if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const ordUTCTime = Data$dDateTime.ordDateTime;
const now = dictMonadEffect => dictMonadEffect.liftEffect(() => {
  const a$p = Effect$dNow.now();
  return Data$dDateTime$dInstant.toDateTime(a$p);
});
const newtypeUTCTime = {Coercible0: () => {}};
const showUTCTime = {show: x => DateUtils.formatISODateTime(x)};
const toUnixTimestamp = x => Data$dDateTime$dInstant.fromDateTime(x);
const genericUTCTime = {to: x => x, from: x => x};
const fromUTCTime = v => v;
const eqUTCTime = Data$dDateTime.eqDateTime;
const encodeUTCTime = {encode: x => DateUtils.formatISODateTime(x)};
const decodeUTCTime = {
  decode: value => bind1(Foreign$dGeneric$dClass.readString(value))(str => {
    const v = DateUtils.parseISODateTime(str);
    if (v.tag === "Just") { return pure1(v._1); }
    if (v.tag === "Nothing") { return fail(Foreign.$ForeignError("ForeignError", "Invalid ISO8601 datetime: " + Data$dShow.showStringImpl(str))); }
    $runtime.fail();
  })
};
const boundedUTCTime = Data$dDateTime.boundedDateTime;
export {
  UTCTime,
  bind1,
  boundedUTCTime,
  decodeUTCTime,
  encodeUTCTime,
  eqUTCTime,
  fail,
  fromUTCTime,
  genericUTCTime,
  newtypeUTCTime,
  now,
  ordUTCTime,
  parseYYYYMMDDhhmmssDateTime,
  pure1,
  showUTCTime,
  toUnixTimestamp,
  unscrambleDecodeUTCTime
};
